import { dispatch } from 'store'
import store from 'store'
import { IAIImageSocketMessage } from 'types/aiImage'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { updateMediaItemWithAIImageData } from 'utils/aiImage'
import { aiImageThunks } from 'store/features/aiImage/thunks'
import { creditsThunks } from 'store/features/credits/thunks'
import { MediaStatus } from 'types/media'
import { ErrorKeys } from 'consts/errorKeys'
import { handleApiError } from 'store/utils'
import { generationProgressService } from 'services/generationProgress'

export const handleAIImgSocketData = (data: IAIImageSocketMessage) => {
  const state = store.getState()

  const { width: canvasWidth, height: canvasHeight } =
    projectDataSelectors.defaultDimensions(state)
  const pendingAiImgMediaItems =
    projectDataSelectors.pendingAiImgMediaItems(state)

  const { imageId, error, filePath, width, height } = data

  const mediaItem = pendingAiImgMediaItems.find(
    item => item.assetId === imageId.toString()
  )
  // no matter if the item was deleted from timeline, we need to update the history and progress
  if (error) {
    dispatch(aiImageThunks.deleteHistoryItem(imageId))
    generationProgressService.stop({
      mediaItemId: mediaItem?.id,
      assetId: String(imageId),
      shouldRemoveFromStorage: true
    })
  }
  if (filePath && width && height) {
    dispatch(
      aiImageThunks.updateHistoryItem(imageId, {
        filePath,
        thumbnailPath: filePath,
        id: imageId,
        status: MediaStatus.OK
      })
    )
  }

  if (mediaItem) {
    if (error) {
      dispatch(handleApiError(ErrorKeys.AI_IMAGE_GENERATION_FAILED))
      dispatch(projectDataThunks.removeVisualMediaItem(mediaItem.id))
      return
    }

    if (filePath && width && height) {
      generationProgressService.complete({
        mediaItemId: mediaItem.id,
        assetId: mediaItem.assetId
      })
      dispatch(
        projectDataThunks.updateMediaAfterGeneration(
          updateMediaItemWithAIImageData(mediaItem, filePath, width, height, {
            width: canvasWidth,
            height: canvasHeight
          }),
          {
            isUndoable: false
          }
        )
      )

      dispatch(creditsThunks.getUserCredits())
    }
  }
}
